import { atom } from "jotai";

export const IsCodeReferenceBlockEditorEmpty = atom<boolean>(false);
